import { ColorJSON } from '../Data';
import { getMaterialColor } from '../utils/colorHelper';
import { PaneMaterial } from '../constants';

export class Color {
  readonly id: number;
  readonly name: string;
  readonly nameEn: string;
  readonly reference: string;
  readonly hexa: string;
  readonly order: number;
  readonly active: boolean;
  readonly opacity: number;
  readonly texture?: string;

  constructor(
    id: number,
    name: string,
    nameEn: string,
    reference: string,
    hexa: string,
    order = 0,
    active = true,
    opacity = 1,
    texture?: string,
  ) {
    this.id = id;
    this.name = name;
    this.nameEn = nameEn;
    this.reference = reference;
    this.hexa = hexa;
    this.order = order;
    this.active = active;
    this.opacity = opacity;
    if (texture) this.texture = texture;
  }

  static fromJSON(json: ColorJSON): Color {
    const o = Object.create(Color.prototype);
    return Object.assign(o, this, json);
  }

  static reviver(key: string, value: any): any {
    return key === '' ? Color.fromJSON(value) : value;
  }

  static fromModel(model: ColorJSON) {
    const { id, name, nameEn, reference, hexa, order, active, opacity } = model;
    return new Color(id, name, nameEn, reference, hexa, order, active, opacity);
  }

  static setupColors(colorsData: any[]): Color[] {
    const colors: Color[] = [];
    for (const colorItem of colorsData) {
      colors.push(Color.fromModel(colorItem));
    }
    return colors;
  }

  get hexaNum(): number {
    return parseInt(`0x${this.hexa}`);
  }

  get hexaHtml(): string {
    return `#${this.hexa}`;
  }

  get material(): PaneMaterial | null {
    try {
      return getMaterialColor(this);
    } catch (error) {
      return null;
    }
  }
}
